import { useState } from 'react'
import cn from 'classnames'
import { timezoneDate, preventDefault } from 'utils/helpers'
import { FollowupDateModal } from 'components/common/modals/FollowupDateModal'
import { HAS_FOLLOWUP_DATE_STAGES } from 'utils/constants'

import s from './DateInfo.scss'

const DateInfo = ({
  id,
  status,
  followUpDate,
  dueDate,
  updateDealFollowupDate,
  dealsStatuses,
  wonDate,
  lostDate
}) => {
  const [showDealFollowup, setShowDealFollowup] = useState(false)
  const [followUpDateStages] = useState(HAS_FOLLOWUP_DATE_STAGES)
  const deal = {
    id,
    followUpDate
  }
  const [categoryCode] = useState(() => {
    if (status.category) {
      return status.category.code
    } else {
      return dealsStatuses[status].category.code
    }
  })
  const toggleFollowupDateModal = () => {
    setShowDealFollowup(!showDealFollowup)
  }

  const onSave = (date, event) => {
    updateDealFollowupDate(id, date, event, status)
  }

  const renderDate = () => {
    if (followUpDateStages.includes(categoryCode) && followUpDate) {
      return (
        <>
          <FollowupDateModal
            entity={deal}
            onSave={onSave}
            showFollowupDateModal={showDealFollowup}
            toggleFollowupDateModal={toggleFollowupDateModal}
            title="Opportunity"
          />
          <div
            title="Follow-up Date"
            className={cn(s.followUpDate, s.pullLeft)}
            onClick={e => {
              preventDefault(e)
              toggleFollowupDateModal()
            }}
          >
            {timezoneDate(followUpDate)}
          </div>
        </>
      )
    } else if (categoryCode === 'won') {
      return (
        wonDate && (
          <div title="Won on Date" className={cn(s.wonDate, s.pullLeft)}>
            {timezoneDate(wonDate)}
          </div>
        )
      )
    } else if (categoryCode === 'lost') {
      return (
        lostDate && (
          <div title="Lost on Date" className={cn(s.lostDate, s.pullLeft)}>
            {timezoneDate(lostDate)}
          </div>
        )
      )
    } else {
      return (
        dueDate && (
          <div title="Bid Due Date" className={cn(s.dueDate, s.pullLeft)}>
            {timezoneDate(dueDate)}
          </div>
        )
      )
    }
  }

  return renderDate()
}

export default DateInfo
